import React from 'react';

import RichTextConverter from '../../Common/RichText/RichTextConverter';
import * as styles from './QuoteSidebar.module.scss';

const QuoteIcon = (className) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="148"
    height="121"
    fill="none"
    viewBox="0 0 148 121"
    className={className}
  >
    <path d="M114.252 120.373c-17.476 0-32.895-11.314-32.895-38.057 0-41.828 31.181-77.486 64.077-81.943v36.343c-10.623 2.4-18.161 8.572-22.958 18.857 14.734 3.429 25.014 16.115 25.014 32.229 0 18.514-13.707 32.571-33.238 32.571m-80.867 0C15.909 120.373.49 109.059.49 82.316.49 40.488 31.67 4.83 64.224.373v36.343c-10.28 2.4-17.818 8.572-22.616 18.857 14.735 3.429 25.014 16.115 25.014 32.229 0 18.514-13.706 32.571-33.237 32.571"></path>
  </svg>
);

export default function QuoteSidebar({ sidebar, colorTheme }) {
  return (
    <div data-analytics-component={'tabbed-folder-quote-sidebar'}>
      {sidebar.sectionCopy && (
        <div className={[styles.quote, styles[colorTheme]].join(' ')}>
          <QuoteIcon className={styles[colorTheme]} />
          <RichTextConverter copy={sidebar.sectionCopy} />
        </div>
      )}
      {sidebar.content.map((item, i) => {
        return (
          <div className={styles.content} key={i}>
            <h4>{item.title}</h4>
            <RichTextConverter copy={item.body} />
          </div>
        );
      })}
    </div>
  );
}
